<template>
  <div class="wrapper">
    <AdminBreadCrumb title="広告主管理" />
    <EditAdvertiser
      @onTextChange="onTextChange"
      @pagination="pagination"
      :search-and-filter="searchAndFilter"
      :on-active-filter-change="onActiveFilterChange"
      :change-sort="changeSort"
      :advertiser-list="advertiserList"
      :agency-list="agencyList"
      :agency-account-list="agencyAccountList"
      :push-new-item="pushNewItem"
      :push-edited-item="pushEditedItem"
      :loading="loading"
      :is-super-admin="isSuperAdmin"
      :sort-options="sortOptions"
      @save="init"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdmin } from '@/mixins/setDrawerTypeAdmin'
import { setToolBarTypeAdmin } from '@/mixins/setToolBarTypeAdmin'
import { actions as advertiserActions } from '@/vuex/modules/admin/advertiser/constants'
import EditAdvertiser from '@/components/Admin/EditAdvertiser/EditAdvertiser'
import AdminBreadCrumb from '@/components/Shared/BreadCrumb/AdminBreadCrumb'

export default {
  components: { EditAdvertiser, AdminBreadCrumb },
  mixins: [accountInitializer, setDrawerTypeAdmin, setToolBarTypeAdmin],
  data() {
    return {
      searchAndFilter: {
        keyword: '',
        activeFilter: { active: true, inactive: true },
        pageNo: 1,
        pageSize: 100,
      },
      sortOptions: {
        sortBy: 'id',
        descending: true,
      },
    }
  },
  computed: {
    ...mapGetters('account', ['isSuperAdmin']),
    loading() {
      return this.$store.getters['admin/advertiser/loading']
    },
    advertiserList() {
      return this.$store.getters['admin/advertiser/searchResult']
    },
    agencyList() {
      return this.$store.getters['admin/advertiser/agencyList']
    },
    agencyAccountList() {
      return this.$store.getters['admin/advertiser/agencyAccountList']
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // view権限を持っている広告主一覧取得
      this.setAdvertisers()
    },
    async pushNewItem(newItem) {
      await this.$store.dispatch(advertiserActions.ADD_ADVERTISER, {
        item: newItem,
      })
      await this.$store.dispatch(advertiserActions.GET_ADVERTISER_LIST, {
        minPermissionLevel: 'view',
      })
    },
    async pushEditedItem(editedItem, id) {
      await this.$store.dispatch(advertiserActions.EDIT_ADVERTISER, {
        id,
        body: editedItem,
      })
      await this.$store.dispatch(advertiserActions.GET_ADVERTISER_LIST, {
        minPermissionLevel: 'view',
      })
    },
    onTextChange(keyword) {
      this.searchAndFilter.keyword = keyword
      this.searchAndFilter.pageNo = 1
      this.setAdvertisers()
    },
    onActiveFilterChange(e) {
      const state = !this.searchAndFilter.activeFilter[e]
      this.searchAndFilter.activeFilter[e] = state
      this.searchAndFilter.pageNo = 1
      this.setAdvertisers()
    },
    pagination(pageNo) {
      this.searchAndFilter.pageNo = pageNo
      this.setAdvertisers()
    },
    changeSort(header) {
      if (!header.sortable) return
      const column = header.value
      const newSortOptions = {
        ...this.searchAndFilter.sortOptions,
      }
      if (newSortOptions.sortBy === column) {
        newSortOptions.descending = !newSortOptions.descending
      } else {
        newSortOptions.sortBy = column
        newSortOptions.descending = false
      }
      this.searchAndFilter.sortOptions = newSortOptions
      this.setAdvertisers()
    },
    setAdvertisers() {
      this.$store.dispatch('admin/advertiser/SEARCH', {
        keyword: this.searchAndFilter.keyword,
        minPermissionLevel: 'view',
        advertiserStatuses: this.getFilteredStatuses(),
        pageNo: this.searchAndFilter.pageNo,
        pageSize: this.searchAndFilter.pageSize,
        sortKey: this.sortOptions.sortBy,
        sortDirection: this.sortOptions.descending ? 'desc' : 'asc',
      })
    },
    getFilteredStatuses() {
      const active = this.searchAndFilter.activeFilter.active
      const inactive = this.searchAndFilter.activeFilter.inactive
      if (active && !inactive) {
        return ['active']
      } else if (!active && inactive) {
        return ['inactive']
      } else if (!active && !inactive) {
        return []
      } else {
        return ['active', 'inactive']
      }
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
</style>
